var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg24(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_50071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.40949 12.3638H3.59395V13.5356H2.40949V12.3638Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70898 12.3638H5.89348V13.5356H4.70898V12.3638Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.88547V18.1311H2.41578V20.5H17.5842V18.131H20V9.88547H0ZM16.4123 19.3281H3.58766V16.1218H4.69586V17.9406H5.86773V16.1218H7.06484V17.9406H8.23672V16.1218H9.43383V17.9406H10.6057V16.1218H11.8028V17.9406H12.9747V16.1218H14.1718V17.9406H15.3437V16.1218H16.4124L16.4123 19.3281ZM18.8281 16.9591H17.5842V14.9498H2.41578V16.9591H1.17188V11.0573H18.8281V16.9591Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9977 0.5C11.1975 0.5 10.4813 0.866953 10.0086 1.44137C9.53586 0.866953 8.81977 0.5 8.01949 0.5H3.125V8.65762H16.875V0.5H11.9977ZM11.9977 1.67188H15.7031V5.0857H11.9977C11.4807 5.0857 10.9988 5.23883 10.5949 5.50219V3.07543C10.5949 3.07039 10.5946 3.06543 10.5945 3.06039C10.6027 2.2934 11.2288 1.67188 11.9977 1.67188ZM4.29688 1.67188H8.01949C8.78836 1.67188 9.41453 2.2934 9.42266 3.06039C9.42262 3.06543 9.42227 3.07039 9.42227 3.07543V5.50215C9.0184 5.23883 8.53652 5.0857 8.01949 5.0857H4.29688V1.67188ZM4.29688 6.25758H8.01949C8.73398 6.25758 9.32504 6.79438 9.41168 7.48574H4.29688V6.25758ZM15.7031 7.48574H10.6055C10.6921 6.79434 11.2832 6.25758 11.9977 6.25758H15.7031V7.48574Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_50071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/24.ba3ef3e8b72ed367d005ecaadd09a09c.svg";
export { ForwardRef as ReactComponent };